import React from 'react';
import styled from 'styled-components';
import { Select as AntdSelect } from 'antd';
import {
  SelectProps as AntdSelectProps,
  LabeledValue as AntdLabeledValue,
} from 'antd/lib/select';
import { LayoutContext } from 'contexts';
import LabelWrapper, { LabelWrapperProps } from '../LabelWrapper';

export interface SelectProps extends AntdSelectProps<any> {
  label?: LabelWrapperProps['label'];
  error?: string | boolean | null;
  position?: 'before' | 'after';
  required?: boolean;
  zIndex?: number;
  dataCy?: string;
}

export type LabeledValue = AntdLabeledValue;

export const Select: React.FC<SelectProps> = ({
  label,
  error,
  position,
  required,
  mode,
  placeholder,
  getPopupContainer,
  dropdownStyle,
  zIndex = 1001,
  className,
  children,
  ...props
}) => {
  const dataCy = (props as any)['data-cy'] ?? props.dataCy;
  const layout = React.useContext(LayoutContext);

  const getContainerFunction = () => {
    if (getPopupContainer) return getPopupContainer;
    if (layout?.scrollContainer) return () => layout.scrollContainer;
    return null;
  };

  return (
    <LabelWrapper
      label={label}
      error={error}
      position={position}
      required={required}
      className={className}
      dataCy={`${dataCy}-container`}
    >
      <AntdSelect
        {...props}
        mode={mode}
        dropdownStyle={{ zIndex, ...dropdownStyle }}
        placeholder={placeholder || (mode ? 'Choose many' : 'Choose one')}
        getPopupContainer={getContainerFunction()}
      >
        {children}
      </AntdSelect>
    </LabelWrapper>
  );
};

export const SelectOption = AntdSelect.Option;
export default styled(Select)``;
